import { Component, OnInit, Injector, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { AnonymousSubject } from 'rxjs-compat';
import { GetRenewalCompareService } from '../../adapters/getRenewalCompare.service';
import { default as theme } from './../renewal-theme.json';
import { CommonService } from '../../claim/services/common.service';
import { BaseComponents } from '../../base.component';
import * as uuid from 'uuid'
@Component({
    selector: 'app-insurance-compare',
    templateUrl: './insurance-compare.component.html',
    styleUrls: ['./insurance-compare.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InsuranceCompareComponent extends BaseComponents implements OnInit {

  compare_data: any = [{
    insuranceLogo: "",
    insuranceName: "",
    insuranceType: "",
    insuranceClaim: "",
    insuranceFund: "",
    totalAmount: 0,
    letterucid: "",
    protection1: 0,
    protection2: 0,
    protection3: 0,
    protection4: 0,
    protection5: 0,
    protection6: 0,
    protection7: 0,
    protection8: 0,
    protection9: 0,
    protection10: 0,
    protection11: 0,
    itemAdditional: [],
    itemSpecial: []
  }];

  itemCompareMaster: any = [];
  itemCompareMain = signal<any>([]);
  itemCompare = signal<any>([]);
  compareFirst: number;
  electronic_channel: any;
  show_itemAdditional = signal<boolean>(false);
  show_itemSpecial = signal<boolean>(false);
  line_spacial_height: string = "";

  special_item = signal<boolean>(false);

  logo: string[] = [];

  dataucid: string;
  letterucid: string;
  rm_channelId: string;
  liff_id: string;
  product_type: number;
  comcode: string;

  loader = signal(false);

  logoInsurance: string;

  style: any = {};
  ucid: string = uuid.v4();
  log_text :string = `insurance-compare ${this.ucid} `;
  show_additional_products = signal<boolean>(false);
  subChannel:number| null = null;

  constructor(
    protected injectorObj:Injector,
    private getRenewalCompareService: GetRenewalCompareService,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService) { 
      super(injectorObj);
    }


  ngOnInit() {
    const logFunction = `${this.log_text} ngOnInit => `
    this.logger.info(logFunction,"page motor-detail start");
    this.route.queryParams.subscribe(params => {
      this.dataucid = params['dataucid'];
      this.letterucid = params['letterucid'];
      this.rm_channelId = params['rm_channelId'];
      this.liff_id = params['appRef'];
      this.product_type = params['product_type'];
      this.electronic_channel = params['electronic_channel'];
      this.comcode = params['comcode'];
      this.style = theme[this.comcode];
      this.subChannel = params['subchannel'] ? parseInt(params['subchannel']) : null
      this.logger.info(logFunction,"params:",params);
      const request = { description: "LINE_RENEW_CONFIG" };
      this.logger.info(logFunction,"get common config LINE_RENEW_CONFIG start");
      this.commonService.apiGetCommonConfig(request).subscribe(
        (response) => {
          if(response && response.data){
            this.logger.info(logFunction,"get common config LINE_RENEW_CONFIG success:",response.data.value);
            try{
              const dataJSON = JSON.parse(response.data.value);
              const configData = dataJSON.TOPUP_DISPLAY[this.electronic_channel];
              this.logger.info(logFunction,"get common config LINE_RENEW_CONFIG configData:",configData);
              if(configData == "Y"){
                this.logger.info(logFunction,"get common config LINE_RENEW_CONFIG configData ==  Y");
                this.show_additional_products.set(true);
              }else{
                this.logger.info(logFunction,"get common config LINE_RENEW_CONFIG configData ==  N");
                this.show_additional_products.set(false);
              }
            }catch(err){
              this.logger.error(logFunction,"get common config LINE_RENEW_CONFIG fail:",err.message);
              this.show_additional_products.set(false);
            }
          }
          
        },
        (error) => {
          this.logger.error(logFunction,"get common config LINE_RENEW_CONFIG fail:",error.message);
          this.show_additional_products.set(false);
        }
      )
      this.getData(this.dataucid);
    });
  }

  getData(dataucid: string) {
    this.getRenewalCompareService.exec({ dataucid: dataucid,electronic_channel:this.electronic_channel }).then((res: any) => {
      console.log(res);
      this.compare_data = res.data.dataobj;
      this.loader.set(true);
      console.log(this.compare_data);

      for (let l = 0; l < this.compare_data.length; l++) {
        if (this.compare_data[l].itemSpecial.length > 0) {
          this.special_item.set(true);
        }
      }

      for (let j = 0; j < this.compare_data.length; j++) {
        if (this.letterucid == this.compare_data[j].letterucid) {
          this.itemCompare.update(arr => [...arr, this.compare_data[j]]);
          this.compareFirst = j;
        }
      }

      for (let k = 3; k > 0; k--) {
        for (let i = 0; i < this.compare_data.length; i++) {
          if ((this.compare_data[i].itemNo == k) && (i != this.compareFirst)) {
            this.itemCompare.update(arr => [...arr , this.compare_data[i]]);
          }
        }
      }

      for (let i = 0; i < this.itemCompare.length; i++) {
        this.logo[i] = "/images/" + this.itemCompare()[i]?.insuranceLogo;
      }

      console.log(this.itemCompare());
      this.itemCompareMaster = JSON.parse(JSON.stringify(this.itemCompare()));
      let firstItem: any;
      this.itemCompare.update(arr => {
        firstItem = arr[0];
        return arr.slice(1); 
      });
      this.itemCompareMain.set([firstItem]);
      console.log(this.itemCompare());
      console.log(this.itemCompareMain);
      let spacial_max = 0;
      this.itemCompareMaster.map(list => {
        if (list.itemAdditional.length > 0) {
          this.show_itemAdditional.set(true);
        }
        if (list.itemSpecial.length > 0) {
          this.show_itemSpecial.set(true);
          spacial_max = list.itemSpecial.length;
        }
      });

      if (this.show_itemSpecial()) {
        this.line_spacial_height = this.calSpacialHeight(spacial_max);
      }
    });
  }

  onSelectLetter(letterucid: string) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "dataucid": this.dataucid,
        "letterucid": letterucid,
        "rm_channelId": this.rm_channelId,
        "appRef": this.liff_id,
        "product_type": this.product_type,
        "electronic_channel": this.electronic_channel,
        "comcode": this.comcode,
        "subchannel": this.subChannel
      }
    };
    this.router.navigate(['/renewal/motor-step'], navigationExtras);
  }

  numberWithCommas(x: number) {
    if (x == 0) {
      return '-'
    } else {
      return String(x).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }

  formatMoney(amount) {
    const fixedNumber = Number.parseFloat(amount.toFixed(2));
    return String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  setLogo(index: number) {
    document.getElementById(String(index)).setAttribute('src', this.logo[index]);
    return this.itemCompareMaster[index].insuranceName;
  }

  calSpacialHeight(num: number) {
    // console.log(`${num*1.2*2}rem`)
    return `${num * 1.0 * 2}rem`;
  }


}
